import Styleguide from "@store/Framework/Types/Styleguide";

const storePickup: Styleguide["storePickup"] = {};

export default storePickup;
